import { withQuery } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (
    src,
    { modifiers = {} } = {}
) => {

    const baseURL = useRuntimeConfig().public.backendUrl + "/image/optimize";

    return {
        url: withQuery(baseURL, { url: src, ...modifiers }),
    }
}

export default {
    getImage,
}
